// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 3 ? "build-glob" : chunkId) + "-legacy." + {"3":"16521367","34":"7def9950","147":"555d362b","162":"c4446ad4","395":"1b302ccf","666":"4a28bc1f"}[chunkId] + ".js";
};